import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";

import { PackageTreesCard } from "./component";
import { IStoreState } from "../../../../reducers/types";

export const mapStateToProps = (_: IStoreState) => {
  return {};
};

export const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type PackagesTreesConnectorProps = ConnectedProps<typeof connector>;

export const ConnectedPackageTreesCard = withRouter(
  connector(PackageTreesCard)
);
